<template >
  <v-list-item v-if="permitido" link :to="{ name: linkname }" @click="emit()" style="background-color: #114b5f; color: white">
    <v-list-item-action v-if="icon">
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>{{ texto }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["icon", "texto", "linkname"],
  computed: {
    ...mapState("comun", ["Permisos"]),
    permitido() {
      if (this.$route.path.split("/")[1].toUpperCase() == "AUTOGESTIONBENEFICIARIOS") {
        return true;
      }
      if (this.$route.path.split("/")[1].toUpperCase() == "MICROSITIOPRESTADORES") {
        return true;
      }
      let permito = this.Permisos.find(
        (x) => x.descripcion_permiso === this.linkname
      );
      return permito !== undefined;
    },
  },
  methods: {
    emit() {
      this.$emit("linkclickeado");
    },
  },
};
</script>

<style></style>
